import React from 'react';
import { Button as AntButton } from 'antd';
import { ButtonProps as AntdButtonProps } from 'antd/es/button';
import { ReactNode } from 'react';

interface CustomButtonProps extends Omit<AntdButtonProps, 'variant'> {
  variant: 'primary' | 'secondary';
  iconPosition?: 'start' | 'end';
  icon?: ReactNode;
}

const IconButton = React.forwardRef<HTMLButtonElement, CustomButtonProps>(
  ({ variant, icon, iconPosition = 'start', children, ...props }, ref) => {
    const type = variant === 'primary' ? 'primary' : 'default';

    return (
      <AntButton type={type} ref={ref} shape="round" {...props}>
        {icon && iconPosition === 'start' && (
          <span style={{ marginRight: 8 }}>{icon}</span>
        )}
        {children}
        {icon && iconPosition === 'end' && (
          <span style={{ marginLeft: 8 }}>{icon}</span>
        )}
      </AntButton>
    );
  },
);

IconButton.displayName = 'IconButton';

export default IconButton;
